import { render, staticRenderFns } from "./CtrlSelect.vue?vue&type=template&id=4a548596&scoped=true&"
import script from "./CtrlSelect.vue?vue&type=script&lang=ts&"
export * from "./CtrlSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlSelect.vue?vue&type=style&index=0&id=4a548596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a548596",
  null
  
)

export default component.exports